import { InjectionToken, Provider } from '@angular/core';
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { LanguagesActionTypes } from '../../../../../../core/site-context/store/actions/languages.action';
import { NewsState } from '../news-state';
import * as newsEntitiesReducer from './news-entities.reducer';
import * as newsPageReducer from './news-page.reducer';

export function getReducers(): ActionReducerMap<NewsState, any> {
  return {
    pages: newsPageReducer.reducer,
    entities: newsEntitiesReducer.reducer,
  };
}

export const reducerToken = new InjectionToken<ActionReducerMap<NewsState>>('NewsReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};

export function clearNewsState(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    if (action.type === LanguagesActionTypes.LanguageChange) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearNewsState];
